
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11202",
                "data-name": "矩形 11202",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0.136 -0.412)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_242",
        "data-name": "蒙版组 242",
        "class": "cls-2",
        "transform": "translate(-0.136 0.412)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "nuanqi",
            "class": "cls-3",
            "d": "M55.2,7.332a.954.954,0,0,1,1,.9v3.15h2V8.232a.954.954,0,0,1,1-.9h2a.954.954,0,0,1,1,.9v3.15h2V8.232a.954.954,0,0,1,1-.9h2a.954.954,0,0,1,1,.9v3.15h.5a.453.453,0,1,1,0,.9h-.5v4.95a.954.954,0,0,1-1,.9h-2a.954.954,0,0,1-1-.9v-4.95h-2v4.95a.954.954,0,0,1-1,.9h-2a.954.954,0,0,1-1-.9v-4.95h-2v4.95a.954.954,0,0,1-1,.9h-2a.954.954,0,0,1-1-.9v-4.95h-.5a.453.453,0,1,1,0-.9h.5V8.232a.954.954,0,0,1,1-.9h2Zm-.5.9h-1a.477.477,0,0,0-.5.45v8.1a.477.477,0,0,0,.5.45h1a.477.477,0,0,0,.5-.45v-8.1a.477.477,0,0,0-.5-.45Zm6,0h-1a.477.477,0,0,0-.5.45v8.1a.477.477,0,0,0,.5.45h1a.477.477,0,0,0,.5-.45v-8.1a.477.477,0,0,0-.5-.45Zm6,0h-1a.477.477,0,0,0-.5.45v8.1a.477.477,0,0,0,.5.45h1a.477.477,0,0,0,.5-.45v-8.1a.477.477,0,0,0-.5-.45ZM56.477.354a.392.392,0,0,1-.185.553c-.469.227-.675.5-.675.874s.206.648.685.88a1.8,1.8,0,0,1,1.148,1.6,1.756,1.756,0,0,1-1.038,1.537l-.109.058a.5.5,0,0,1-.464.015.394.394,0,0,1-.009-.721l.019-.009c.477-.245.686-.528.686-.88s-.209-.635-.675-.874A1.769,1.769,0,0,1,54.7,1.78,1.725,1.725,0,0,1,55.748.236l.11-.056a.485.485,0,0,1,.619.174Zm7.333,0a.392.392,0,0,1-.185.553c-.468.227-.675.5-.675.874s.207.648.686.88a1.8,1.8,0,0,1,1.148,1.6,1.756,1.756,0,0,1-1.038,1.537l-.11.058a.5.5,0,0,1-.464.015.394.394,0,0,1-.009-.721l.019-.009c.477-.245.686-.528.686-.88s-.209-.635-.675-.874a1.768,1.768,0,0,1-1.158-1.6A1.726,1.726,0,0,1,63.081.235L63.191.18a.485.485,0,0,1,.618.174Zm-3.667,0a.392.392,0,0,1-.185.553c-.469.227-.675.5-.675.874s.206.648.686.88a1.8,1.8,0,0,1,1.147,1.6,1.756,1.756,0,0,1-1.038,1.537l-.109.058a.488.488,0,0,1-.62-.145.389.389,0,0,1,.147-.561l.019-.009c.476-.245.686-.528.686-.88s-.209-.635-.675-.874a1.769,1.769,0,0,1-1.159-1.6A1.727,1.727,0,0,1,59.415.235l.11-.056a.485.485,0,0,1,.619.174Z",
            "transform": "translate(-48.064 2.456)"
          }
        }
      ]
    }
  ]
})
    }
  